import { KeyImage } from '../services/imaging/common';

export interface SeReportState {
    patientId: string | null;
    currentExaminationIds: {
        ecg: string[];
        visit: string[];
    };
    isModified: boolean;
    keyImages: KeyImage[];
    isPreview: boolean;
    imagesPerRowInPlaceholder: number;
}

export const seReportInitialState: SeReportState = {
    keyImages: [],
    currentExaminationIds: {
        ecg: [],
        visit: [],
    },
    isModified: false,
    patientId: null,
    isPreview: false,
    imagesPerRowInPlaceholder: 1
};
